import { Model } from "@gaming/srvg-classes-core";
import { CompetitionStage } from "../Data/CompetitionStage";

export const COMPETITIONSTAGE_MODEL_COMPETITIONSTAGE = 'competitionStage';

export class CompetitionStageModel extends Model {
    competitionStage: CompetitionStage;

    constructor() {
        super();
        this.competitionStage = null;
    }

    setCompetitionStage( competitionStage: CompetitionStage ) {
        this.setProperty( COMPETITIONSTAGE_MODEL_COMPETITIONSTAGE, competitionStage );
    }

    destroy() {
        this.competitionStage = null;
        super.destroy();
    }
}